import { forwardRef, Ref, useImperativeHandle, useState } from "react"
import { BaseInput } from "../../../../../../../../../components"
import { onChange } from "../../../../../../../../../utils/types"
import { ForceClosureActivityProps, ForceClosureActivityRef } from "./types"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { FooterSimple } from "../../../../../../../../../components/buttons/footer"

export const ForceClosureActivity = forwardRef(({ cancel, confirm }: ForceClosureActivityProps, ref: Ref<ForceClosureActivityRef>) => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState({ input: { reason: { value: '', label: '', }, }, })
    const [error, setError] = useState('');
    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        setValue((prev) => ({
            ...prev,
            input: {
                [name as 'reason']: {
                    ...prev.input[name as 'reason'],
                    value,
                },
            },
        }))
        if (value.length < 3) {
            setError('El campo debe contener mínimo 3 caracteres');
        } else {
            setError('');
        }
    }

    useImperativeHandle(ref, () => ({
        getData: { reason: value?.input?.reason?.value ?? '' },
        loading: (value) => {setLoading(() => value)}
    }))
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
            <BaseInput
                fullWidth
                sx={{
                    width: '100%',
                    
                  }}
                name="reason"
                placeholder={t('general.closeComment', {postProcess: ['required']})}
                label={t('general.closeComment', {postProcess: ['required']})}
                onChange={onChange}
                value={value.input}
                type="alphaNumeric"
                multiline
                rows={4}
                error={!!error}
                helperText={error && t('general.minCharacters', { count: 3 })}
            />

            <FooterSimple
                cancel={{
                    children: t('general.cancel'),
                    onClick: cancel
                }}
                confirm={{
                    children: t('general.forcingCloseActivity'),
                    loading: loading,
                    disabled: !value.input.reason.value || value.input.reason.value.length<3,
                    onClick: confirm,
                    variant: 'primary_c'
                }}
            />
        </Box>
    )
})